import { render } from "./NoticeIcon.vue?vue&type=template&id=b69a313c&scoped=true"
import script from "./NoticeIcon.vue?vue&type=script&lang=js"
export * from "./NoticeIcon.vue?vue&type=script&lang=js"

import "./NoticeIcon.vue?vue&type=style&index=0&id=b69a313c&lang=css"
import "./NoticeIcon.vue?vue&type=style&index=1&id=b69a313c&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b69a313c"]])

export default __exports__